<script setup>
import { Link, useForm } from "@inertiajs/inertia-vue3";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import RadioButton from "primevue/radiobutton";
import Dropdown from "primevue/dropdown";
import Slider from "primevue/slider";
import Textarea from "primevue/textarea";
import { VueSignaturePad } from "vue-signature-pad";
import { ref } from "vue";

const emits = defineEmits(["save"]);
const props = defineProps([
    "processing",
    "form",
    "errors",
    'isEdit',
    'v$',
]);
const value = ref(10);
const signaturePad = ref(null)
const isShowSignaturePad = ref((! props.isEdit) || (! props.form.signature))

const clearSignature = () => {
    signaturePad.value.clearSignature()
}

const changeSignature = () => {
    isShowSignaturePad.value = true
    // signaturePad.value.openSignaturePad()
}
</script>
<template>
    <div class="lato p-7 rounded my-2">
        <div class="my-7">
            <div class="font-bold">
                Hiermit bestätige ich, dass ich alle Fragen wahrheitsgetreu
                beantwortet habe.
            </div>

            <div class="my-4">
                <div class="max-w-3xl">
                    <VueSignaturePad v-if="isShowSignaturePad"
                                     class="w-full rounded border border-[#94a3b8] mb-2"
                                     :class="{
                                        'border-[#f87171]': errors.signature,
                                     }"
                                     height="500px"
                                     ref="signaturePad"></VueSignaturePad>
                    <div  v-else class="w-full rounded border border-[#94a3b8] mb-2">
                        <img :src="form.signature" class="max-w-full h-[500px]" />
                    </div>

                    <div class="flex items-center justify-between">
                        <div v-if="errors.signature" class="text-sm text-[#dc2626]">
                            {{ errors.signature[0] }}
                        </div>

                        <div class="flex gap-3">
                            <Button v-if="isShowSignaturePad"
                                    severity="danger"
                                    size="small" @click="clearSignature">Klar</Button>
                            <Button v-else
                                    size="small"
                                    @click="changeSignature">ändern</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex mt-10 justify-end">
            <Button
                label="speichern"
                class="min-w-[100px] !bg-black !text-[#FFF053] !border-none"
                @click="emits('save', signaturePad)"
                :loading="processing"
            />
        </div>
    </div>
</template>
